export enum WorkbookPageQa {
    Layout = 'workbook-page-layout',
    ListItem = 'workbook-page-list-item',
    ListItemName = 'workbook-page-list-item-name',
    MenuDropDownBtn = 'workbook-page-list-item-menu-btn',
    MenuItemDuplicate = 'workbook-page-list-item-menu-item-duplicate',
    Filters = 'workbook-page-filters',
    ChunkScope = 'workbook-page-chunk-scope-',
}

export const WorkbookPageActionsMoreQA = {
    SWITCHER: 'workbook-page-actions-more-switcher',
    DELETE_ITEM: 'workbook-page-actions-more-delete-item',
};

export const WorkbookDialogQA = {
    APPLY_BUTTON: 'workbook-dialog-apply-button',
    ROOT_IMPORT_SUCCESS: 'workbook-dialog-import-success',
    TITLE_INPUT: 'workbook-dialog-title-input',
};
